import SectionTitle from '../../components/SectionTitle';
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
  AccordionIcon,
  Text,
  VStack,
} from '@chakra-ui/react';

export default function FAQSection() {
  return (
    <VStack w="100%" py="10">
      <SectionTitle title="Frequently Asked Questions" />
      <Accordion allowMultiple w="100%">
        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              What happens to unclaimed tokens?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              Once the migration window closes, all unclaimed tokens will be burned.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              Which chains are included?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              Migration applies to $XED on all chains (Ethereum, BNB Chain, Polygon), with new
              tokens on Ethereum Mainnet.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              How will liquidity be handled?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              First we will remove liquidity from all existing liquidity pools in all three chains
              according to the above roadmap. Once the new token is issued liquidity will be added
              to a new contract pool on Uniswap using the Ethereum network.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              Is this only for tokens in BNB Chain and Polygon?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              No, the migration applies to $XED in all chains, including Ethereum. Token holders
              will have to claim the new $XED tokens in Ethereum Mainnet.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
          mb="2"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              How to migrate $XED tokens?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              Detailed instructions for migrating your $XED tokens will be provided closer to the
              migration date. Rest assured, our team is committed to facilitating a seamless
              transition for every member of our community.
            </Text>
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem
          border="0"
          bg="whiteAlpha.200"
          backdropFilter="blur(25px)"
          borderRadius="16px"
        >
          <AccordionButton py="4">
            <Text flex="1" textAlign="left">
              Is $XED going to exist only on Ethereum?
            </Text>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={4}>
            <Text fontSize="sm" color="whiteAlpha.800" fontWeight="light">
              Yes for the $XED token as it allows concentration of liquidity and better usability
              but we have plans to expand our ecosystem to other blockchains and eventually build
              our own blockchain in the Phase 3 of the DAO evolution. Detailed migration
              instructions will be provided closer to the launch date. The migration marks the
              beginning of true community ownership in Exeedme's ecosystem, where holders become
              active participants in shaping the future in gaming, esports and digital property
              rights
            </Text>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
